// Vocabulario unico de botones del portal.
//
// Antes cada pantalla y cada popup escribia sus clases a mano, y el resultado
// era un radio distinto por lugar — `rounded-lg` (8px) en el boton principal,
// `rounded-[10px]` en la hoja de objeciones del email, `rounded-md` (6px) en el
// banner de typo — mas tamaños y pesos de tipografia que no coincidian. Contra
// el branding de un partner eso se lee como "esto lo hizo otro": el popup
// desentona del formulario que tiene detras.
//
// Todo sale de aca. El radio es el mismo que el de los inputs (`rounded-lg`),
// asi los botones y los campos que comparten columna cierran igual. Los colores
// son tokens de branding, nunca valores fijos.

export type ButtonVariant = 'primary' | 'secondary' | 'accent' | 'ghost';
export type ButtonSize = 'md' | 'sm';

const BASE =
  'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 ' +
  'focus-visible:ring-offset-background disabled:opacity-50 disabled:cursor-not-allowed';

const SIZES: Record<ButtonSize, string> = {
  // Igual que el boton de submit: 44px de alto minimo (target tactil) y el
  // cuerpo de texto del formulario.
  md: 'min-h-[2.75rem] px-4 py-2.5 text-base',
  // Acciones secundarias dentro de un banner inline, donde un boton de 44px
  // pesaria mas que el texto que lo acompaña.
  sm: 'min-h-[2.25rem] px-3 py-1.5 text-sm',
};

const VARIANTS: Record<ButtonVariant, string> = {
  primary: 'bg-primary text-white hover:opacity-90',
  secondary: 'border border-border bg-background text-text hover:bg-text-muted/10',
  accent: 'border border-accent text-accent hover:bg-accent/10',
  ghost: 'border border-transparent text-text-muted hover:text-text',
};

export function btn(
  variant: ButtonVariant = 'primary',
  size: ButtonSize = 'md',
  extra = '',
): string {
  return `${BASE} ${SIZES[size]} ${VARIANTS[variant]}${extra ? ` ${extra}` : ''}`;
}
